// extracted by mini-css-extract-plugin
export default {"imageContainer":"InfoHotspotModal_imageContainer__ptLyI","image":"InfoHotspotModal_image__qdlbX","hotspotContainer":"InfoHotspotModal_hotspotContainer__OcjqO"};